import { Theme, css } from '@emotion/react';

export const title = ({ colors, spacing }: Theme) => css`
  border-bottom: 1px solid ${colors.borderDefault};
  padding-bottom: ${spacing(4)}px;
`;
